import { useGeolocation } from 'state/geolocation';

interface IUseSearchingProps {
  searchingNearby: boolean;
  searchingRecent: boolean;
  searchingFavs: boolean;
}
interface ISearching {
  isSearchingFavorites: boolean;
  isSearchingNearby: boolean;
  isSearchingRecent: boolean;
}

export const useSearching = ({
  searchingNearby,
  searchingRecent,
  searchingFavs,
}: IUseSearchingProps): ISearching => {
  const { coordinatesAvailable, isPermissionChecking, isPermissionGranted } = useGeolocation();

  /**
   *   - searchingNearby
   *     - AND we have a coordinates to search
   *       (we need manual|automatic coord to search something - without that we don't search)
   *       (this also handles the case where we know permissions are denied, but we have manual coords)
   *   - we're checking permissions
   *   - we have granted permissions
   *     - AND we have no available coords to search
   *     (ex. we're in the waiting time between getting granted permissions
   *      and actually receiving the user's coords)
   */
  const isSearchingNearby =
    (searchingNearby && coordinatesAvailable) ||
    isPermissionChecking ||
    (isPermissionGranted && !coordinatesAvailable);

  const isSearchingRecent = searchingRecent || isPermissionChecking;

  const isSearchingFavorites = searchingFavs || isPermissionChecking;

  return {
    isSearchingFavorites,
    isSearchingNearby,
    isSearchingRecent,
  };
};
